import React from 'react';

const TableWrapper = ({ children, footer }) => (
  <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
    <div className="overflow-x-auto">
      <table className="w-full text-left">{children}</table>
    </div>
    {footer && (
      <div className="px-6 py-3 border-t border-slate-100 bg-white text-xs text-slate-400 font-medium">
        {footer}
      </div>
    )}
  </div>
);

export const Thead = ({ cols }) => (
  <thead>
    <tr className="border-b border-slate-200 text-[10px] uppercase tracking-widest text-slate-400 font-bold bg-white">
      {cols.map((c, i) => (
        <th key={i} className={`px-6 py-4 ${c.right ? 'text-right' : ''}`}>{c.label}</th>
      ))}
    </tr>
  </thead>
);

export default TableWrapper;